import { FETCH_VERSION_SUCCESS } from '.'

const fetchVersionSuccessAction = (payload) => {
  return {
    type: FETCH_VERSION_SUCCESS,
    payload
  }
}

export { fetchVersionSuccessAction }
